export default __webpack_public_path__ + "static/media/wave-02.4a56e8c7.png";